import { useLayoutEffect, useRef, useState, type ReactNode } from 'react';

const A4_WIDTH_MM = 210;
const PX_PER_MM = 96 / 25.4;
const A4_WIDTH_PX = A4_WIDTH_MM * PX_PER_MM;

export function TemplatePreview({ children }: { children: ReactNode }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0.3);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const update = () => {
      const width = el.clientWidth;
      if (width > 0) setScale(width / A4_WIDTH_PX);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative aspect-[210/297] w-full overflow-hidden rounded-md bg-white shadow-sm ring-1 ring-black/5"
      aria-hidden
    >
      <div
        className="absolute left-0 top-0 origin-top-left"
        style={{ width: `${A4_WIDTH_PX}px`, transform: `scale(${scale})` }}
      >
        {children}
      </div>
    </div>
  );
}
